import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader, Divider, Grid,
    IconButton, Link, Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { stringToLocaleDateString } from '../../../../helpers';
import { UtenteLink } from '../../../common';
import { NavContext, NavRoutes } from "../../../contexts";
import { TipoUfficioContext } from '../TipoUfficioContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const TipiList = ({
    disabled,
    onActionClick,
    ...props }) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,
    } = useContext(TipoUfficioContext);

    const {
        tipi,
    } = state;

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addNewClickHandler = () => {
        navigateTo(NavRoutes.TipoUfficioAdd,)
    }

    return (
        <>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            sx={{
                                color: "white",
                                backgroundColor: "secondary.main",
                            }}
                            title={
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="h6">Tipi uffici</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            color="info"
                                            onClick={addNewClickHandler}
                                        >
                                            Aggiungi
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                        />
                        <Divider />
                        <CardContent sx={{ padding: "0px !important" }}>
                            <Table>
                                <TableHead sx={{
                                    backgroundColor: "aliceblue",
                                }}>
                                    <TableRow>
                                        <TableCell style={{ width: "50%" }}>NOME TIPO</TableCell>
                                        <TableCell style={{ width: "10%" }}>ORDINE</TableCell>
                                        <TableCell style={{ width: "10%" }}>
                                            INSERITO DA
                                        </TableCell>
                                        <TableCell style={{ width: "10%" }}>
                                            MODIFICATO DA
                                        </TableCell>
                                        <TableCell style={{ width: "10%" }}>
                                            DATA INSERIMENTO
                                        </TableCell>
                                        <TableCell style={{ width: "10%" }}>
                                            DATA MODIFICA
                                        </TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        tipi?.result.length > 0 ? tipi?.result.map((tipo, index) => <TableRow key={index}>
                                            <TableCell style={{ width: "70%" }}>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <div>
                                                        <Link
                                                            component="button"
                                                            color="textPrimary"
                                                            onClick={() => navigateTo(NavRoutes.TipoUfficio, [tipo.id])}
                                                            sx={{ fontWeight: 700, }}>
                                                            {tipo.nome}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell style={{ width: "30%" }}>
                                                <Typography>
                                                    {tipo.ordine}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <UtenteLink utenteId={tipo?.creatoDa} />
                                            </TableCell>
                                            <TableCell>
                                                <UtenteLink utenteId={tipo?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell>
                                                {stringToLocaleDateString(tipo.dataCreazione)}
                                            </TableCell>
                                            <TableCell>
                                                {stringToLocaleDateString(tipo.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(tipo)}>
                                                    <Tooltip title="elimina tipo">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>)
                                            :
                                            <TableRow>
                                                <TableCell align="center">
                                                    Nessun elemento
                                                </TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}